import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { BuilderBlocks } from "@builder.io/react";
import { Accordion } from "@faire/web--source/slate/Accordion";
import React from "react";
import { BuilderTypography } from "./BuilderTypography";
export var BuilderAccordion = function(_param) {
    var contents = _param.contents, contentComponents = _param.contentComponents, attributes = _param.attributes, useComponentsForItems = _param.useComponentsForItems, props = _object_without_properties(_param, [
        "contents",
        "contentComponents",
        "attributes",
        "useComponentsForItems"
    ]);
    var _contentComponents_map, _contents_map;
    return /*#__PURE__*/ _createElement(Accordion, _object_spread_props(_object_spread({}, props, attributes), {
        key: attributes.key,
        "builder-id": attributes["builder-id"],
        items: useComponentsForItems ? (_contentComponents_map = contentComponents === null || contentComponents === void 0 ? void 0 : contentComponents.map(function(param) {
            var question = param.question, answer = param.answer;
            return {
                question: /*#__PURE__*/ _jsx(BuilderBlocks, {
                    blocks: question
                }),
                answer: /*#__PURE__*/ _jsx(BuilderBlocks, {
                    blocks: answer
                })
            };
        })) !== null && _contentComponents_map !== void 0 ? _contentComponents_map : [] : (_contents_map = contents === null || contents === void 0 ? void 0 : contents.map(function(param) {
            var question = param.question, answer = param.answer;
            return {
                question: question,
                answer: /*#__PURE__*/ _jsx(BuilderTypography, {
                    textContent: answer,
                    attributes: attributes
                })
            };
        })) !== null && _contents_map !== void 0 ? _contents_map : []
    }));
};
